import {request} from '@api/index.js';
import urls from '@api/urls.ts';
import {useQuery} from '@tanstack/react-query';
import {DURATION_MS} from './util.js';

const getIMSUserStatus = () =>
  request.get(`${urls.ims}/users/me/status`).then(response => response.data);

export const useGetIMSUserStatus = (queryOptions = {}) =>
  useQuery({
    queryKey: ['ims-me-status'],
    queryFn: getIMSUserStatus,
    staleTime: DURATION_MS.HOUR,
    ...queryOptions,
  });
